import React, { useMemo } from "react";
import PropTypes from "prop-types";

import Link from "next/link";
import { useTranslation } from "next-i18next";

import { MONTH_FULL_NAMES_FOR_WEEK } from "../ToggleBlockOfData";
import { useRouter } from "next/router";
import Image from "next/image";

const BlogCard = ({
  date: dateOfPost,
  coverImage: image,
  slug,
  title,
  subtitle,
  color,
  dateStyles,
}) => {
  const {
    i18n: { language },
  } = useTranslation();
  const router = useRouter();
  const {
    query: { club },
  } = router;

  const { dateMonth, dateYear, dateDay, dateHours, dateMinutes } =
    useMemo(() => {
      const date = new Date(dateOfPost);
      return {
        dateMonth: MONTH_FULL_NAMES_FOR_WEEK[language][date.getMonth()],
        dateYear: date.getFullYear(),
        dateDay: date.getDate().toString().padStart(2, 0),
        dateHours: date.getHours().toString().padStart(2, 0),
        dateMinutes: date.getMinutes().toString().padStart(2, 0),
      };
    }, [dateOfPost, language]);

  return (
    <>
      <Link href={`/club/${club}/blog/${slug}`} className="blog-card">
        <>
          <div className="blog-card__link-img-block">
            {image && (
              <Image
                src={image}
                className="blog-card__img"
                alt="banner-img"
                fill
              />
            )}
          </div>

          <p className="blog-card__date" style={{ ...dateStyles }}>
            {`${dateDay} ${dateMonth} ${dateYear}, ${dateHours}:${dateMinutes}`}
          </p>
          <h3 className="blog-card__title" style={{ color }}>
            {title}
          </h3>

          <p className="blog-card__text">{subtitle}</p>
        </>
      </Link>
      <style jsx global>{`
        @import "./BlogCard.scss?8";
      `}</style>
    </>
  );
};

BlogCard.propTypes = {
  date: PropTypes.string,
  coverImage: PropTypes.string,
  slug: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,

  dateStyles: PropTypes.object,
};

BlogCard.defaultProps = {
  date: "",
  coverImage: "",
  slug: "",
  title: "",
  subtitle: "",

  dateStyles: {},
};

export default BlogCard;
